import { Dispatch } from "redux";
import { deleteVehicleFailure, deleteVehicleRequest, deleteVehicleSuccess } from "src/store/actions/vehicles";
import { ActionType } from "src/store/dataService/actions/utils/actionCreator";
import { deleteTo } from "./shared/osfetch";
import { findRoute } from "./util";

export const removeVehicle = async (next: Dispatch, action: ActionType<typeof deleteVehicleRequest>) => {
    const response = await deleteTo(`/deals/${action.payload.uuid}/vehicles/${action.payload.vin}`, {}, next, false);

    if (response.ok) {
        next(deleteVehicleSuccess(action.payload.vin));
    } else {
        next(deleteVehicleFailure(action.payload.vin));
    }
};

const routes = {
    [deleteVehicleRequest.type]: removeVehicle,
};

export default (next: Dispatch, action: any, dispatch?: Dispatch) => findRoute(routes)(next, action, dispatch);
